"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const PassportOrIdFileUpload = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsxs)("label", { htmlFor: props.name, className: 'pointer m-0', children: [(0, jsx_runtime_1.jsx)("span", { children: translate('id_passport_upload', 'აიდი/პასპორტის ატვირთვა') }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", (0, jsx_runtime_1.jsx)("i", { className: 'fas fa-upload' })] })] }) }));
};
exports.default = PassportOrIdFileUpload;
